import axios from 'axios';

const globalURL = 'https://zeusqa.azaonline.in/api/';
// const globalURL = 'https://zeusstage.azaonline.in/api';
// const globalURL = 'https://zeus.azaonline.in/api';


export const devAxios = axios.create({
    baseURL: globalURL,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    },
  });
